export enum AccessLevelEnum {
  GERAL = 'Geral',
  SETOR = 'Setor',
  CONGREGACAO = 'Congregação',
}

export interface SubMenu {
  label: string;
  active: boolean;
  canEdit: boolean;
  canView: boolean;
}

export interface TypePermissions {
  active: boolean;
  label: string;
  accessLevel: AccessLevelEnum | null;
  subMenus: SubMenu[];
}

export interface UserPermissions {
  churches: TypePermissions;
  jobs: TypePermissions;
  users: TypePermissions;
  secretary: TypePermissions;
  settings: TypePermissions;
}

export enum IdTypePermissions {
  SECRETARY = 'SECRETARY',
  SETTINGS = 'SETTINGS',
}

export enum PermissionsEnum {
  DASHBOARD_MODULE = 'dashboard:module',
  TOTAL_TRAFFIC = 'total-traffic:read',
  NEW_USERS = 'new-users:read',
  USER_TURNOVER = 'user-turnover:read',
  NEW_MEMBERS = 'new-members:read',
  REVENUE_COLLECTIONS = 'revenue-collections:read',
  NEW_REGISTERED_USERS = 'new-registered-users:read',
  OVERVIEW = 'overview:read',
  COLLECTIONS_HISTORY = 'collections-history:read',

  CHURCH_MODULE = 'church:module',
  SECTOR_READ = 'sector:read',
  SECTOR_CREATE = 'sector:create',
  SECTOR_UPDATE = 'sector:update',
  CONGREGATION_READ = 'congregation:read',
  CONGREGATION_CREATE = 'congregation:create',
  CONGREGATION_UPDATE = 'congregation:update',

  USER_MODULE = 'user:module',
  VISITOR_READ = 'visitor:read',
  VISITOR_UPDATE = 'visitor:update',
  VISITOR_CREATE = 'visitor:create',
  MEMBER_READ = 'member:read',
  MEMBER_UPDATE = 'member:update',
  MEMBER_CREATE = 'member:create',
  MEMBER_DISABLE_ENABLE = 'member:disable-enable',
  MEMBER_GROUP_READ = 'member-group:read',
  MEMBER_GROUP_CREATE = 'member-group:create',
  MEMBER_GROUP_UPDATE = 'member-group:update',
  MEMBER_GROUP_DELETE = 'member-group:delete',
  GROUP_NOTIFICATION_READ = 'group-notification:read',
  GROUP_NOTIFICATION_SEND = 'group-notification:send',
  REQUEST_GROUP_READ = 'request-group:read',
  REQUEST_GROUP_ACCEPT = 'request-group:accept',
  REQUEST_GROUP_REFUSE = 'request-group:refuse',
  REQUEST_AFFILIATION_READ = 'request-affiliation:read',
  REQUEST_AFFILIATION_ACCEPT = 'request-affiliation:accept',
  REQUEST_AFFILIATION_REFUSE = 'request-affiliation:refuse',

  JOB_MODULE = 'job:module',
  TITLE_READ = 'title:read',
  TITLE_UPDATE = 'title:update',
  TITLE_CREATE = 'title:create',
  FUNCTION_READ = 'function:read',
  FUNCTION_UPDATE = 'function:update',
  FUNCTION_CREATE = 'function:create',
  FUNCTION_DELETE = 'function:delete',
  GROUP_READ = 'group:read',
  GROUP_UPDATE = 'group:update',
  GROUP_CREATE = 'group:create',
  TITLE_CHANGE_READ = 'title-change:read',
  TITLE_CHANGE_REQUEST = 'title-change:request',
  TITLE_CHANGE_PENDING_READ = 'title-change-pending:read',
  TITLE_CHANGE_PENDING_ACCEPT = 'title-change-pending:accept',
  TITLE_CHANGE_PENDING_REFUSE = 'title-change-pending:refuse',

  SECRETARY_MODULE = 'secretary:module',
  TRANSFERENCE_READ = 'transference:read',
  TRANSFERENCE_ACCEPT = 'transference:accept',
  TRANSFERENCE_REFUSE = 'transference:refuse',
  HOMOLOGATION_READ = 'homologation:read',
  HOMOLOGATION_ACCEPT = 'homologation:accept',
  HOMOLOGATION_REFUSE = 'homologation:refuse',
  RECOMMENDATION_READ = 'recommendation:read',
  RECOMMENDATION_REQUEST = 'recommendation:request',
  TO_SIGN_RECOMMENDATION_READ = 'to-sign-recommendation:read',
  TO_SIGN_RECOMMENDATION_SIGN = 'to-sign-recommendation:sign',
  TO_SIGN_RECOMMENDATION_REFUSE = 'to-sign-recommendation:refuse',
  DATA_CHANGE_READ = 'data-change:read',
  DATA_CHANGE_ACCEPT = 'data-change:accept',
  DATA_CHANGE_REFUSE = 'data-change:refuse',
  RECOVERED_ACCOUNTS_READ = 'recovered-accounts:read',
  RECOVERED_ACCOUNTS_ACCEPT = 'recovered-accounts:accept',
  RECOVERED_ACCOUNTS_REFUSE = 'recovered-accounts:refuse',
  ACCOUNTS_TO_CHECK_READ = 'accounts-to-check:read',
  ACCOUNTS_TO_CHECK_BIND = 'accounts-to-check:bind',
  ACCOUNTS_WITHOUT_PASSWORD_READ = 'accounts-without-password:read',

  EVENT_MODULE = 'event:module',
  EVENT_DETAILS_READ = 'event-details:read',
  EVENT_DETAILS_CREATE = 'event-details:create',
  EVENT_DETAILS_UPDATE = 'event-details:update',
  EVENT_DETAILS_DELETE = 'event-details:delete',
  COMPLETED_EVENTS_READ = 'completed-events:read',

  SETTING_MODULE = 'setting:module',
  ADMIN_USERS_READ = 'admin-users:read',
  ADMIN_USERS_UPDATE = 'admin-users:update',
  ADMIN_USERS_DISABLE = 'admin-users:disable',
  TERMS_OF_USE_READ = 'terms-of-use:read',
  TERMS_OF_USE_UPDATE = 'terms-of-use:update',
  REASONS_READ = 'reasons:read',
  REASONS_CREATE = 'reasons:create',
  REASONS_UPDATE = 'reasons:update',

  APP_MODULE = 'app:module',
  TRANSMISSIONS_READ = 'transmissions:read',
  TRANSMISSIONS_UPDATE = 'transmissions:update',
  NEWS_READ = 'news:read',
  NEWS_CREATE = 'news:create',
  NEWS_UPDATE = 'news:update',
  NEWS_DELETE = 'news:delete',
  CONTACT_READ = 'contact:read',
  CONTACT_UPDATE = 'contact:update',
  ABOUT_READ = 'about:read',
  ABOUT_UPDATE = 'about:update',
  INTERNAL_NOTIFICATIONS_READ = 'internal-notifications:read',
  INTERNAL_NOTIFICATIONS_UPDATE = 'internal-notifications:update',
  PUSH_NOTIFICATIONS_READ = 'push-notifications:read',
  PUSH_NOTIFICATIONS_UPDATE = 'push-notifications:update',

  REQUESTS_MODULE = 'requests:module',
  PHYSICAL_CARD_READ = 'physical-card:read',
  PHYSICAL_CARD_ISSUE = 'physical-card:issue',
  PHYSICAL_CARD_SETTINGS_READ = 'physical-card-settings:read',
  PHYSICAL_CARD_SETTINGS_EDIT = 'physical-card-settings:edit',
  CERTIFICATES_READ = 'certificates:read',
  CERTIFICATES_ISSUE = 'certificates:issue',
  CERTIFICATES_SETTINGS_READ = 'certificates-settings:read',
  CERTIFICATES_SETTINGS_EDIT = 'certificates-settings:edit',
}

export enum UserRoles {
  OPERADOR = 'OPERADOR',
  ADMIN = 'ADMIN',
  SUPERADMIN = 'SUPERADMIN',
  VISITANTE = 'VISITANTE',
  MEMBRO = 'MEMBRO',
}

export type UserPermissionsIds = IdTypePermissions | PermissionsEnum;

export const PERMISSIONS = {
  ...IdTypePermissions,
  ...PermissionsEnum,
};
